import apiUrl from '../../../constants'
import axios from 'axios'
import Paginate from 'vuejs-paginate'
import {
	Validator
} from 'vee-validate'
import DatePicker from 'vue2-datepicker'
import CryptoJS from 'crypto-js';
import moment from 'moment'
import {
	BasicSelect
} from 'vue-search-select'
import VueElementLoading from 'vue-element-loading';
import download from 'downloadjs';

export default {
	name: 'creategroup',
	components: {
		Paginate,
		BasicSelect,
		VueElementLoading,
		download
	},
	data: function() {
		return {
			searchFlag: false,
			validateFlag: false,
			bagstatus: '',
			shippingId: '',
			isLoading: false,
			shipmentLimt:false,
			shipmentLimtMsg:'',
			fileinput:'',
			parseShipment:[],
			shipmentTable:false,
			shipmentData:[],
			totalRows:0,
			pageNo: 0,
			limit: 10,
			batchId:'',
			showShipmentDetils:false,
			currentHubId:'',
			showShipmentDetails:[],
			pageCount: 0,
			isLoading:false,
			ImageURLPath:'',
			shipmentno: '',
			showImage:false,
			shipIdLoading:false,
			searcShippingId:'',
			bId:'',
			batchTime:[],
		}
	},

	created: function() {},
	computed: {},
	mounted() {

		var userdetailEncrypt = window.localStorage.getItem('userdetail')
		var bytes = CryptoJS.AES.decrypt(userdetailEncrypt.toString(), 'Key');
		var plaintext = bytes.toString(CryptoJS.enc.Utf8);
		var userdetail = JSON.parse(plaintext);
		this.useremail = userdetail[0].email;
		this.currentHubId=userdetail[0].HubId[0] == undefined ? 0 : userdetail[0].HubId[0]
		// this.getBatchDetails();
	},
	methods: {
		addShipmentData() {
			this.shipmentLimt=false;
			this.shipmentLimtMsg='';
			this.isLoading = true;

			this.input = ({
				shippingIds: this.shippingId,
				createdBy: this.useremail,
				currentHubId:this.currentHubId
			})
			axios({
					method: 'POST',
					'url': apiUrl.api_url_hubops + 'downloadShipmentsImageForSorterFinanceTeam',
					'data': this.input,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25',
					}
				})
				.then((result) => {
					this.isLoading = false;

					if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage);
					}
					if (result.data.ResultCode == 100) {
						this.$alertify.success(result.data.ReturnMessage);
						this.resetForm();
					}
				})
				.catch((httpException) => {
					console.error('exception is:::::::::', httpException)
				})
		},
			onFileChange(e) {
			 var files = e.target.files || e.dataTransfer.files;
			 var parts = files[0].name.split('.');
			 if(parts[1].toLowerCase() !== "csv")
			 {
				 this.$alertify.error("Please select CSV file");
				 return false;
			 }
			 if (!files.length)
					 return;
			 this.createInput(files[0]);
	 	},
		createInput(file) {
		 var reader = new FileReader();
		 var vm = this;
		 reader.onload = (e) => {
		 vm.fileinput = reader.result;
		 this.shippingId=vm.fileinput.replace(/\n/g, ",");
		 this.shippingId=this.shippingId.slice(0,this.shippingId.length-1)

		 }
		 reader.readAsText(file);
 },
 getShipmentData(){
	 this.shipmentLimt=false;
	 this.shipmentLimtMsg=''
	 var shippingIdArray=[];
	 shippingIdArray.push(this.shippingId.split(","));
	 if(shippingIdArray[0].length >1000)
	 {
		 this.shipmentLimt=true;
		 this.shipmentLimtMsg="Please Enter Shipment's Upto 1000"
		 return false;
	 }
	 this.isLoading = true;
	 this.batchId=''
	 axios({
			 method: 'GET',
			 'url': apiUrl.api_url_hubops + `getShipmentDetailsByBatchId?shippingId=${this.shippingId}`, //API for get shipemnt data
			 headers: {
				 'authorization': 'authkey xB84JJ89Hd25',
			 }
		 })
		 .then((result) => {
			 this.isLoading = false;

			 if (result.data.ResultCode == 100) {
				 this.shipmentTable=true;
				 this.shipmentData=result.data.ResponseData[0].shippingIds;
				 this.batchId=result.data.ResponseData[0].batchId
				 // this.totalRows=result.data.TotalCount;
				 // if (this.totalRows < 10) {
					//  this.pageCount = 1
				 // } else {
					//  this.pageCount = Math.ceil(this.totalRows / 10);
				 // }
				 this.$alertify.success(result.data.ReturnMessage);
			 }else{
				 this.$alertify.error(result.data.ReturnMessage);
			 }
		 })
		 .catch((httpException) => {
			 console.error('exception is:::::::::', httpException)
		 })
 },
 getBatchDetails(){
	 this.isLoading=true;

	axios({
			method: 'GET',
			'url': apiUrl.api_url_hubops + `getBatchDetailsByHubId?currentHubId=${this.currentHubId}&createdBy=${this.useremail}&pageNo=${this.pageNo}&pageSize=${this.limit}`,
			headers: {
				'authorization': 'authkey xB84JJ89Hd25',
			}
		})
		.then((result) => {
			this.isLoading=false;

			if (result.data.ResultCode == 100) {
				
				for(var i=0; i<result.data.ResponseData.length; i++){
					this.batchTime[result.data.ResponseData[i].batchId] = false;

					var now  = moment().format('DD-MM-YYYY HH:mm:ss');
					var then = moment(result.data.ResponseData[i].createdDate).format('DD-MM-YYYY HH:mm:ss');

					var duration = moment.duration(moment(now,"DD/MM/YYYY HH:mm:ss").diff(moment(then,"DD/MM/YYYY HH:mm:ss")));
					var minute = duration.asMinutes();

					if(minute > 10){
						this.batchTime[result.data.ResponseData[i].batchId] = true;
					}
				}

				this.shipmentTable=true;
				this.totalRows = result.data.TotalCount
				if (this.totalRows < 10) {
					this.pageCount = 1
				} else {
					this.pageCount = Math.ceil(this.totalRows / 10);
				}
				this.shipmentData=result.data.ResponseData;
			}else{
				this.shipmentTable=false;
				this.$alertify.error(result.data.ReturnMessage);
			}
		})
		.catch((httpException) => {
			console.error('exception is:::::::::', httpException)
		})
 },
 getPaginationData(pageNum) {
	 this.pageNo = (pageNum - 1)
	 this.getBatchDetails()
 },
		resetForm() {
			this.shippingId = '';
			document.getElementById("uploadFile").value=null;
			this.bagstatus = '';
			this.shipmentLimt=false;
			this.shipmentLimtMsg=''
			this.$validator.reset();
			this.shipmentTable=false;
			this.totalRows=0;
			this.pageNo=0;
		},
		// downloadImage(data, ind) {
		// 	console.log(data,"data");
		// 	console.log(1);
		// 	axios({
		// 			method: 'GET',
		// 			url: apiUrl.api_url_hubops + 'downloadImageForSorter?Imageurlpath=' + data.imageUrlPath,
		// 			headers: {
		// 				'authorization': 'authkey xB84JJ89Hd25'
		// 			}
		// 		})
		// 		.then(result => {
		// 			if (result.data.ResultCode == 100) {
		// 				console.log(result.data.ReturnMessage,"result");
		// 				this.ImageURLPath = result.data.ReturnMessage;
		// 				// var a = document.createElement('a');
		// 				// a.href = this.ImageURLPath;
		// 				// a.download = this.ImageURLPath;
		// 				// document.body.appendChild(a);
		// 				// a.click();
		// 				// document.body.removeChild(a);
		// 				// document.getElementById('imgid' + data.ShippingID).download = this.ImageURLPath;
		// 				// document.getElementById('imgid' + data.ShippingID).href = this.ImageURLPath;
		// 				$('#pdfid' + data.shippingId).hide();
		// 				$('#imgid' + data.shippingId).show();
		// 				$('#shipmentno').hide();
		// 				document.getElementById('imgid' + data.ShippingId).src = this.ImageURLPath;
		// 				var modal = document.getElementById('myModalimg' + data.shippingId);
		// 				var img = document.getElementById('imgid' + data.shippingId);
		// 				var modalImg = document.getElementById("img01" + data.shippingId);
		// 				modal.style.display = "block";
		// 				modalImg.src = this.ImageURLPath;
		// 			} else {
		// 				this.ImageURLPath = '';
		// 				$('#shipmentno').show();
		// 				this.$alertify.error(result.data.ReturnMessage)
		// 			}
		// 		}, error => {
		// 			console.error(error)
		// 		})
		// },

		onSubmit: function(formname) {
			this.$validator.validateAll().then((formResult) => {
					if (formResult == false) {
						this.validateFlag = false
					} else {
						if(/\r?\n|\r|\\t/g.test(this.shippingId) == true){
							this.shippingId = this.shippingId.replace(/\r?\n|\r|\\t/g,',');
						}
						if(/\s/g.test(this.shippingId) == true || this.shippingId.indexOf(',') > -1){
			        this.shippingId = this.shippingId.replace(/\n|"|'| |,\s*$/g,'').split(',').filter(item => item);
			      }
						// if(this.shippingId.length >1000){
						// 	this.shipmentLimt=true;
						// 	this.shipmentLimtMsg="Please Enter Shipment's Upto 1000";
						// 	 return false;
						// }
						if(Array.isArray(this.shippingId) == true){
							this.shippingId = this.shippingId.join(',');
						}

						if(!this.shippingId){
							this.validateFlag = false
						}else{
							this.validateFlag = true;
							this.addShipmentData();
							console.log('form is valid')
						}
					}
				})
				.catch(() => {
					console.log('errors exist')
				});
		},
		closeModal() {
			this.showShipmentDetils = false;
			$(document.body).removeClass("modal-open");
			$(".modal-backdrop").remove();
		},
		// HUB-8332: consolidated batch read (optional shippingId filter)
		fetchBatchShipmentDetails(batchId, shippingId, loadingKey) {
			let url = apiUrl.api_url_hubops + `getSorterBatchShipmentDetails?batchId=${batchId}`;
			if (shippingId) {
				url += `&shippingId=${shippingId}`;
			}
			if (loadingKey === 'modal') {
				this.isLoading = true;
			} else {
				this.shipIdLoading = true;
			}
			axios({
				method: 'GET',
				url,
				headers: {
					'authorization': 'authkey xB84JJ89Hd25',
				}
			})
				.then((result) => {
					if (loadingKey === 'modal') {
						this.isLoading = false;
					} else {
						this.shipIdLoading = false;
					}
					if (result.data.ResultCode == 101) {
						this.$alertify.error(result.data.ReturnMessage);
					}
					if (result.data.ResultCode == 100) {
						const rows = result.data.ResponseData.shippingIds || [];
						if (loadingKey === 'modal') {
							this.shipmentImageData1 = this.shipmentImageData = rows;
							this.showShipmentDetils = true;
						} else {
							this.shipmentImageData = rows;
						}
					}
				})
				.catch((httpException) => {
					if (loadingKey === 'modal') {
						this.isLoading = false;
					} else {
						this.shipIdLoading = false;
						this.$alertify.error('Error Occured');
					}
					console.error('exception is:::::::::', httpException);
				});
		},
		showImageDetails(data){
			this.searcShippingId = '';
			this.bId = data;
			this.fetchBatchShipmentDetails(data, null, 'modal');
			// HUB-8332 backup — legacy getShipmentDetailsByBatchId
			// this.isLoading=true; this.searcShippingId = '';
			// this.bId = data;
			// axios({
			// 	 method: 'GET',
			// 	 'url': apiUrl.api_url_hubops + `getShipmentDetailsByBatchId?batchId=${data}`,
			// 	 headers: {
			// 		 'authorization': 'authkey xB84JJ89Hd25',
			// 	 }
			//  })
			//  .then((result) => {
			// 	 this.isLoading=false;
			// 	 if (result.data.ResultCode == 101) {
			// 		 this.$alertify.error(result.data.ReturnMessage);
			// 	 }
			// 	 if (result.data.ResultCode == 100) {
			// 		 this.shipmentImageData1=this.shipmentImageData=result.data.ResponseData[0].shippingIds;
			// 		 this.showShipmentDetils=true;
			// 	 }
			//  })
			//  .catch((httpException) => {
			// 	 console.error('exception is:::::::::', httpException)
			//  })
		},
		downloadImage(data, ind) {
			this.shipIdLoading = true;
			axios({
					method: 'GET',
					url: apiUrl.api_url_hubops + 'downloadImageForSorter?Imageurlpath=' + data.imageUrlPath,
					headers: {
						'authorization': 'authkey xB84JJ89Hd25'
					}
				})
				.then(result => {
					if (result.data.ResultCode == 100) {
						this.ImageURLPath = result.data.ReturnMessage;

						var link = document.createElement('a');
						link.href = result.data.ReturnMessage;
						link.download = 'Download.jpg';
						link.setAttribute('target','_blank');
						document.body.appendChild(link);
						link.click();
						document.body.removeChild(link);

						// var a = document.createElement('a');
						// a.href = this.ImageURLPath;
						// a.download = this.ImageURLPath;
						// document.body.appendChild(a);
						// a.click();
						// document.body.removeChild(a);
						// document.getElementById('imgid' + data.ShippingID).download = this.ImageURLPath;
						// document.getElementById('imgid' + data.ShippingID).href = this.ImageURLPath;
						// $('#pdfid' + data.shippingId).hide();
						// $('#imgid' + data.shippingId).show();
						// $('#shipmentno').hide();
						// console.log('imgid' + data.shippingId,"'imgid' + data.shippingId");
						// document.getElementById('imgid' + data.shippingId).src = this.ImageURLPath;
						// var modal = document.getElementById('myModalimg' + data.shippingId);
						// var img = document.getElementById('imgid' + data.shippingId);
						// var modalImg = document.getElementById("img01" + data.shippingId);
						// modal.style.display = "block";
						// modalImg.src = this.ImageURLPath;
						// this.showImage=true;

					} else {
						this.ImageURLPath = '';
						//$('#shipmentno').show();
						this.$alertify.error(result.data.ReturnMessage)
					}
					this.shipIdLoading = false;
				}, error => {
					console.error(error); this.shipIdLoading = false;
				})
		},
		closemodal(id) {
			var modal = document.getElementById(id);
			modal.style.display = "none";
			this.showImage=false;
			$('#shipmentno').show();
		},

		//to get shipment data using shipping & batch id
    getSearchedShipments() {
			document.getElementById("ssId").innerHTML='';
			if(!this.searcShippingId){
        document.getElementById("ssId").innerHTML="Shipping Id is required."; return false;
      }
      this.fetchBatchShipmentDetails(this.bId, this.searcShippingId, 'search');
			// HUB-8332 backup — legacy getShipmentDetailsByAWBBatchIdForFinanceTeam
			// this.shipIdLoading = true;
			// axios({
			//     method: 'GET',
			//     url: apiUrl.api_url_hubops + `getShipmentDetailsByAWBBatchIdForFinanceTeam?batchId=${this.bId}&shippingId=${this.searcShippingId}`,
			//     headers: {
			//       'Authorization': 'authkey xB84JJ89Hd25'
			//     }
			//   })
			//   .then(result => {
			// 		if (result.data.ResultCode == 101) {
			// 			 this.$alertify.error(result.data.ReturnMessage);
			// 		 }
			// 		 if (result.data.ResultCode == 100) {
			// 			 this.shipmentImageData=result.data.ResponseData;
			// 		 }
			// 		 this.shipIdLoading = false;
			//   }, error => {
			// 		this.shipIdLoading = false;
			//     console.error('error is:::::::::', error)
			//     this.$alertify.error('Error Occured');
			//   })
    },

		resetShipping() {
			this.searcShippingId = ''; document.getElementById("ssId").innerHTML='';
			this.shipmentImageData = this.shipmentImageData1;
			this.shipIdLoading = false;
			this.$validator.reset();
		},

    generateZip(batchId) {
      this.isLoading = true;
      this.input = ({
      	batchId: batchId,
      	status: "Close"
      })
      axios({
          method: 'POST',
          'url': apiUrl.api_url_hubops + 'generateZip',
          'data': this.input,
          'headers': {
            'authorization': 'authkey xB84JJ89Hd25',
          }

        })
        .then(result => {
	 				 if (result.data.ResultCode == 100) {
						 this.getBatchDetails();
	 					 this.$alertify.success(result.data.ReturnMessage);
	 				 }else{ this.$alertify.error(result.data.ReturnMessage); }
 					 this.isLoading = false;
        }, error => {
					this.isLoading = false;
          console.error('error is:::::::::', error)
          this.$alertify.error('Error Occured');
        })
    },

		downloadZip(url) {
				var link = document.createElement('a');
				link.href = url;
				link.download = 'Download.jpg';
				link.setAttribute('target','_blank');
				document.body.appendChild(link);
				link.click();
				document.body.removeChild(link);
		},

		updateBatchStatus(data){
			this.input = {
        currentHubId: this.currentHubId,
        batchId: data.batchId,
        status: 'InProcess',
				shipmentCount:data.shippingIds.length
      }
      axios({
        'method': 'POST',
        'url': apiUrl.api_url_hubops + 'updateBatchStatus',
        'data': this.input,
        'headers': {
          'authorization': 'authkey xB84JJ89Hd25',
        }
      })
      .then(result => {
        if (result.data.ResultCode == 100) {
          this.$alertify.success(result.data.ReturnMessage)
          this.getBatchDetails()
        } else {
          this.$alertify.error(result.data.ReturnMessage)
        }
      }, error => {
        console.error(error)
      })
		},

		jsonToCSV(filename, data, csvfield, dateFilder = [], skipFilter = []) {
     var csvData = ''
     //Header
     if (this.title != null) {
       csvData += this.parseExtraData(this.title, '${data}\r\n')
     }
     //Fields
     for (let key in data[0]) {
       if (skipFilter.indexOf(key) == -1)
         csvData += csvfield[key] + ','
     }
     csvData = csvData.slice(0, csvData.length - 1)
     csvData += '\r\n'
     //Data
     data.map(function(item) {
       for (let key in item) {
         if (skipFilter.indexOf(key) == -1) {
           var escapedCSV = item[key] + '' // cast Numbers to string
           if (escapedCSV.match(/[,"\n]/)) {
             escapedCSV = '"' + escapedCSV.replace(/\"/g, "\"\"") + '"'
           }
           if (escapedCSV == 'null')
             csvData += ',';
           else {
             if (dateFilder.indexOf(key) != -1)
               csvData += moment(escapedCSV).format('DD-MM-YYYY HH:mm:ss') + ','
             else
               csvData += escapedCSV + ','
           }
         }
       }
       csvData = csvData.slice(0, csvData.length - 1)
       csvData += '\r\n'
     })
     //Footer
     if (this.footer != null) {
       csvData += this.parseExtraData(this.footer, '${data}\r\n')
     }
     filename += moment().format('DD-MM-YYYY') + '.csv';
     return this.export(csvData, filename, "application/csv");
     return csvData
   },

    export (data, filename, mime) {
     let blob = this.base64ToBlob(data, mime)
     download(blob, filename, mime)
   },

    base64ToBlob(data, mime) {
     let base64 = window.btoa(window.unescape(encodeURIComponent(data)))
     let bstr = atob(base64)
     let n = bstr.length
     let u8arr = new Uint8ClampedArray(n)
     while (n--) {
       u8arr[n] = bstr.charCodeAt(n)
     }
     return new Blob([u8arr], {
       type: mime
     })
   },

	 exportImageUrl(shippingArr) {
		 this.isLoading=true;

		 let expArr = shippingArr.map(i => ({ shippingId:i.shippingId, presignedImageURL:(i.presignedImageURL) ? i.presignedImageURL : 'N/A' }));

			this.csvFields = {
				'shippingId': 'Shipping ID',
				'presignedImageURL': 'Image Url'
			}

			this.jsonToCSV('ShipmentsImageFile_', expArr, this.csvFields);
			this.isLoading=false;
	 },
	}
}



// WEBPACK FOOTER //
// ./src/views/components/SorterImageDownload/SorterImageDownload.js